export const EMAIL_CONFIG = {
  serviceId: "glowroom_service",
  publicKey: "EiQkRKe-lYZcuQdqt",
  templateConfirmacion: "template_348q8on",
};